import angular from 'angular';

import CalendarPeriodModule from './calendar-period';

export default angular
    .module('application.scene.authorized.scene.calendar.component.calendar-header.component', [
        CalendarPeriodModule.name
    ]);



// WEBPACK FOOTER //
// ./src/application/scene/authorized/scene/calendar/component/calendar-header/component/index.js